// extracted by mini-css-extract-plugin
export default {"divShake":"PurchaseDiv_divShake__htUOp","horizontal-shaking":"PurchaseDiv_horizontal-shaking__LiU+h"};